import React, {useEffect, useState} from "react";
import { Button } from "@mui/material";
import {useNavigate, useSearchParams} from "react-router-dom";
import axios from "axios";
import * as constants from './../constants'
import MenuAppBar from "../components/MenuAppBar";

const DefaultPage = () => {
    const [error, setError] = useState('')
    useEffect(() => {
        let code = window.location.href.split('?code=')[1]
        if (code !== undefined) {
            axios.post(constants.serverURL + "getToken", {
                "code": code
            },      {
                withCredentials: true,
            }).then(response => {
                window.location.href = constants.websiteURL + "#/main"
            }).catch((error) => {
                setError(error.request.responseText)
            })
        } else {
            axios.post(constants.serverURL + "tokenRefresh", [], {
                withCredentials: true,
            }).then(response => {
                if (response.status === 200) {
                    window.location.href = constants.websiteURL + "#/main"
                }
            }).catch((error) => {
                setError(error.request.responseText)
            })
        }
    }, [])


    const goToLogin = () => {
        window.location.href = constants.cognitoURL
    }
    return (
        <div>
            <MenuAppBar title="" signedIn={false}></MenuAppBar>
                <div className="screen">
                <h1>
                    Welcome to athLEDA!
                </h1>
                <p className="center-align font-18">Log in to get started</p>
                <Button className="m-form-button" variant="outlined" onClick={goToLogin}>Log in</Button>
            </div>
        </div>
    );
};

export default DefaultPage;